import ENG from "./en.json";
import ESP from "./es.json";
import FRE from "./fr.json";

export const defaultLocale = "ENG";

export const languages = {
  ENG,
  ESP,
  FRE,
};
